import { render } from "./GatewayMainList.vue?vue&type=template&id=64531036"
import script from "./GatewayMainList.vue?vue&type=script&lang=js"
export * from "./GatewayMainList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__